<template>
  <logoAnimated></logoAnimated>
</template>

<script>
import logoAnimated from '~/components/icons/logo-animated/LogoAnimated'
export default {
  components: {
    logoAnimated,
  },
}
</script>
